$(document).ready(function($) {
    var companyId = $('#company_id');
    var jobCompanyId = $('#job_company_id');
    var categoryId = $('#categoryId');
    var subscribeModal = $('#subscribe-modal');

    
    $(document).on("click", ".applied_job_list_item, .job-list-item, .invited_job_list_item .job_item_link", function (e) {
        var expired = $(this).find(".expiredJob");
        if (expired.length) {
            let url;
            if ($(this).hasClass('applied_job_list_item')) {
                url = $(this).data('action');
            } else {
                url = $(this).parents('.applied_job_list_item').data('action');
            }

            $.get(url, function (data) {
                var expiredJob = $('#expired_job');
                expiredJob.find('.modal-content').html(data);
                expiredJob.modal('show');
            });
        }
    });

    $(document).on("click", ".single-job-navigation a", function(e) {
        var element = $(this).attr("href");

        $('html, body').animate({
            scrollTop: $(element).offset().top - 40
        }, 500);

        e.preventDefault();
    });

    subscribeModal.on('hidden.bs.modal', function () {
        $('.follow_type_block').addClass('no_display');
    });

    $('#company_active_job_carousel').on("click", '.subscribe-save-company-job', function(e) {
        companyId.val($(this).data('companyid'));
        jobCompanyId.val($(this).data('companyid'));
        categoryId.val($(this).data('categoryid'));
        $('#job_item_id').val($(this).closest('.web_item_card').data('id'));

        companyId.prop('checked', true);
        jobCompanyId.prop('checked', true);
        categoryId.prop('checked', true);

        categoryId.closest('label').find('.inner').remove();
        companyId.closest('label').find('.inner').remove();
        jobCompanyId.closest('label').find('.inner').remove();

        categoryId.closest('label').append('<span class="inner">' + $(this).data('categorytitle') + '</span>');
        companyId.closest('label').append('<span class="inner">' + $(this).data('companytitle') + '</span>');
        jobCompanyId.closest('label').append('<span class="inner">' + $(this).data('companytitle') + '</span>');

        $('#subscribe-modal-job').modal("show");
        return false;
    });

    $('#search_list_block, #company_follow_block').on("click", '.subscribe-save-company', function(e) {

        $('#company_id').val($(this).attr('data-companyid'));
        $('#company_name').text($(this).data('companytitle'));
        $('#item_id').val($(this).closest('.web_item_card').attr('data-id'));
        subscribeModal.find('.single_follow_block').removeClass('no_display');
        subscribeModal.modal("show");
        return false;
    });

    $(window).scroll(function(){
        setJobInnerNavigation();
        setTrainingsInnerNavigation();
    });

    function setJobInnerNavigation() {
        var windowOffset =  $(document).scrollTop();
        var headerHeight = 0;
        if($('#header').length){
            headerHeight = $('#header').outerHeight();
        }
        else {
            headerHeight = $('header').outerHeight();
        }
        var topBlockWidth = $('.single-job .container').outerHeight() + $('.hs_job_page_container #header_info_block').outerHeight() + headerHeight + 15;
        if(windowOffset <= topBlockWidth){
            var asd = topBlockWidth - windowOffset;
            var top = asd.toString() + 'px';
            $('.single-job-navigation').css('top', top)
            $('.single-job-navigation').find(".btn-success").hide();
        } else {
            $('.single-job-navigation').find(".btn-success").css('display', 'inline-block');
            $('.single-job-navigation').css('top', '0px')
        }
    }
    setJobInnerNavigation();
    setTrainingsInnerNavigation();
    setTimeout(function(){
        setJobInnerNavigation();
        setTrainingsInnerNavigation();
    }, 500)

    function setTrainingsInnerNavigation() {
        var windowOffset =  $(document).scrollTop();
        var site_type = $('#site_type').val();
        var top_pos = 361;
        if(site_type === 'hirebee'){
            top_pos = 373;
        }

        if(windowOffset <= top_pos){
            var asd = top_pos - windowOffset;
            var top = asd.toString() + 'px';
            $('.single-trainings-navigation').css('top', top)
            $('.single-trainings-navigation').find(".btn-success").hide();
        } else {
            $('.single-trainings-navigation').find(".btn-success").show();
            $('.single-trainings-navigation').css('top', '0px')
        }
    }

    $(document).on("click", ".jobs-sidebar-toggle", function(e) {
        e.preventDefault();

        $(".sidebar-inner").stop().slideToggle();
    });

    $(".information_application_block").bind('copy', function() {
        var self = $(this);
        var id = $(this).data('id');
        var emailList = $(this).data('emails');
        var copiedText = window.getSelection().toString();
        clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
        clipboardData.setData('text/html', copiedText);

        if ($.inArray( copiedText, emailList) !== -1){
            $.ajax({
                type: "POST",
                url: '/jobs/job-announcement/add-cv-submits?id=' + id,
                success: function (data) {
                }
            });
        }
    });


    $('.desc_email').on('click', function() {
        $.ajax({
            type: "POST",
            url: '/jobs/job-announcement/add-cv-submits?id=' + $(this).data('id'),
            success: function (data) {
            }
        });

    })

});

function suggestCvSend(email) {

    $.ajax({
        type: "POST",
        data: {email: email},
        url: $('#suggest_cv_send_url').val(),
        success: function (response) {

            if(response.success) {
                $('#hs_default_modal').find('.modal-body').html(response.content);
                $('#hs_default_modal').modal('show')
            }


        }
    });

}